export default __webpack_public_path__ + "static/media/Nigeria.bc494419.png";